import React, {useState} from 'react';
import {Folha} from '../../../componentes/folha/folha';
import {SelecionaNFe} from './componentes/seleciona-nfe';
import {Row, Col, Empty, Layout, Button, Upload, Drawer, Modal} from 'antd';
import {DetalhaNFeCompleta} from './componentes/detalhe-nfe-completa';
import {DetalhaResumoNFe} from './componentes/detalha-resumo-nfe';
import { useAxios } from '../../../hooks';


const { Sider, Content} = Layout;

const EntradaNFe = () => {
    const [nfeSelecionada, setNFeSelecionada] = useState({});
    const [recarregaNFeListeners] = useState([]);
    const [removerLoading, setRemoverLoading] = useState(false);

    const {getApiEmitirNotas} = useAxios();

    const registraRecarregaNFeListener = (func) => {
        recarregaNFeListeners.push(func);
    }

    const renderizaNFe = () => {
        if(nfeSelecionada.chaveNFe){
            return renderizaNFeSelecionada();
        } else {
            return rendereziaNoDada();
        }
    }

    const executarBuscaDeNotas = () => {
        setTimeout(()=>{
            recarregaNFeListeners.forEach(func => {    
                func && func();
            });
        }, 1000);
    }
    const aoFinalizarConferencia = () => {
        executarBuscaDeNotas();
        
        // buscaNotasNaoProcessadas(setLoadingBuscaNotas, setNotas);
    }

    const aoDownloadNFe = () => {
        executarBuscaDeNotas();
    }

    const aoEnviarCienciaOperacao = () => {
        executarBuscaDeNotas();
    }
    
    
    const arquivarNFe = async (nfe) => {
        setRemoverLoading(true);
        
        try{

            const api = await getApiEmitirNotas();
            await api.delete(`/fiscal/nfe-contra/${nfe.uuid}`)
            executarBuscaDeNotas();
            setRemoverLoading(false);
        } catch(err){}
        finally{
            setRemoverLoading(false);
        }
    }

    const renderizaNFeSelecionada = () => {
        if(nfeSelecionada.estadoInformacao === 'COMPLETO'){
            return (<DetalhaNFeCompleta nfe={nfeSelecionada} aoFinalizarConferencia={aoFinalizarConferencia} />);
        }  else if(nfeSelecionada.estadoInformacao === 'RESUMO'){
            return (<DetalhaResumoNFe nfe={nfeSelecionada} downloadEvt={aoDownloadNFe} enviaCienciaOperacaoEvt={aoEnviarCienciaOperacao}></DetalhaResumoNFe>)
        } else if(nfeSelecionada.estadoInformacao === 'DESCONHECIDO'){
            return (
            <>
                <Empty description="Sem dados de NFe"></Empty>
                <Button disabled={removerLoading} loading={removerLoading} onClick={()=>{arquivarNFe(nfeSelecionada)}}>Remover</Button>
            </>)
        }
        return (<Empty></Empty>)
    }

    const rendereziaNoDada = () => {
        return (<Empty description="Selecione uma NFe para mostrar as informações"></Empty>);
    }

    return(<Layout>
        <Sider width={300} theme="light" style={{
            background: "#FFF",
           
        }}>
            {/* <Row>
            <Col span='24'> */}
                <FormularioImportacao onImportarArquivo={executarBuscaDeNotas}></FormularioImportacao>
                <SelecionaNFe aoSelecionarNFe={setNFeSelecionada} registraRecarregaNFeListener={registraRecarregaNFeListener} ></SelecionaNFe>
            {/* </Col>

            </Row> */}
        </Sider>
        <Layout >

            <Content style={{
                maxHeight: "calc(100vh - 190px)"
        }} >
                <Row>
            
                    <Col span='24' >
                    
                        <Folha>
                            {renderizaNFe()}
                        </Folha>
                    </Col>
                </Row>

            </Content>
        </Layout>
        
    </Layout>
    
    );
}


const FormularioImportacao = ({
    onImportarArquivo
}) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileContent, setFileContent] = useState("");
    const {getApiEmitirNotas} = useAxios();
    const { confirm } = Modal;

    const openDrawer = ()=> {
        setVisible(true);
    }
    
    const confirmarUpload = async ()=>{
        if(!fileContent){
            confirm({
                title: "Nenhum arquivo selecionado",
                content: "Selecione um arquivo para importar",
                cancelButtonProps: {
                    style:{display: "none"}
                }
            })
            return;  
        }
        setLoading(true);
        try{

            const api = await getApiEmitirNotas();
            const {data} = await api.post("/fiscal/nfe-contra/importacao-arquivo", {
                xmlBase64: fileContent
            });
            if(data.error){
                confirm({
                    title: "Não foi possivel importar o arquivo",
                    content: data.error,
                    cancelButtonProps: {
                        style:{display: "none"}
                    }
                })
                setLoading(false);
                return;
            }
    
            setVisible(false);
        } catch(err){

        } finally {
            setLoading(false);
            onImportarArquivo && onImportarArquivo();

        }
        
        
        
    }
    return (
        <Row>
            <Col span={24}>
                <Button size='small' onClick={openDrawer} style={{width: "100%"}}>Importar Via Arquivo</Button>
                <Modal
                    title="Importar NFe"
                    placement="right"
                    closable={true}
                    visible={visible}
                    width={400}
                    getContainer={true}
                    okText="Confirmar Importação"
                    okButtonProps={{loading: loading}}      
                    cancelText="Cancelar"
                    onCancel={()=>{setVisible(false)}}
                    onOk={()=>{confirmarUpload()}}
                    
                >
                    <Upload
                        accept='.xml'
                        multiple={false}
                        maxCount={1}
                        onRemove={()=> {setFileContent("")}}
                        beforeUpload={(file, fileList)=> {
                            const uid = file.uid;
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                const base64 =  btoa(e.target.result);
                                setFileContent(base64)
                                // console.log(fileContent);
                            }
                            reader.readAsText(file);
                            return false
                        }}
                        onChange={(info) => {
                            console.log(info);
                        }}
                    >
                        <Button  type="primary">Escolher Arquivo</Button>
                    </Upload>
                </Modal>

                
            </Col>
            
        </Row>
    );
}

export {EntradaNFe};